import { CircleAlert, CircleCheck, Info, LoaderCircle, TriangleAlert } from 'lucide-react';
import { Toaster as Sonner, toast, type ToasterProps } from 'sonner';

export { toast };

/** App-wide toast host (sonner), styled only with brand tokens. Mount once at the root. */
export function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      closeButton
      icons={{
        success: <CircleCheck aria-hidden className="size-5 text-state-success" />,
        error: <CircleAlert aria-hidden className="size-5 text-state-danger" />,
        warning: <TriangleAlert aria-hidden className="size-5 text-state-warning" />,
        info: <Info aria-hidden className="size-5 text-primary-text" />,
        loading: <LoaderCircle aria-hidden className="size-5 animate-spin text-muted" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group flex w-(--width) flex-wrap items-start gap-3 rounded-lg border border-border bg-surface-raised p-4 pr-10 text-body text-fg shadow-lg',
          // The words keep a readable width; a long action goes under them, not beside (B-041).
          content: 'min-w-0 flex-1 basis-48',
          title: 'font-semibold',
          // Stations (comfortable density): nothing under 17 px, actions are 48 px targets.
          description: 'text-sm text-muted comfortable:text-label',
          actionButton:
            'ml-auto shrink-0 whitespace-nowrap rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground comfortable:min-h-touch comfortable:px-4 comfortable:text-body',
          cancelButton:
            'shrink-0 whitespace-nowrap rounded-md bg-surface-sunken px-3 py-1.5 text-sm font-medium text-fg comfortable:min-h-touch comfortable:px-4 comfortable:text-body',
          closeButton:
            // Inside its own toast: on a stack it never sits over the toast above (B-018).
            'absolute right-2 top-2 flex size-6 items-center justify-center rounded-full text-muted hover:bg-surface-hover hover:text-fg',
          error: 'border-state-danger/40',
          success: 'border-state-success/40',
          warning: 'border-state-warning/40',
        },
      }}
      {...props}
    />
  );
}
